<template>
    <div class="content">
        <div class="phone-simulator" :style="this.type==1?'width:auto;height:auto':null">
            <iframe :src="iframeSrc" frameborder="0"></iframe>
        </div>
    </div>

</template>

<script>
    export default {
        name: "previewDrawingBoard",
        data() {
            return {
                iframeSrc: '',
                cid: 0,
                type:0
            }
        },
        mounted() {
            this.cid = this.$route.query.cid;
            let previewRoute = this.$router.resolve('m_projectBoard');
            this.iframeSrc = previewRoute.href + '?isPreview=1&cid=' + this.cid;
            if(navigator.userAgent.match('/(phone|pad|pod|iphone|ipad|ios|Android)/i')){
                this.type = 0
            }else{
                this.type = 1
            }
        },
        methods: {

        }
    }
</script>

<style lang="less" scoped>
    .content {
        background-color: #cccccc;
        position: absolute;
        padding-top: 18px;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        overflow: auto;
    }
    .phone-simulator {
        background-color: #fff;
        padding: 0;
        margin: 0 auto;
        width: 375px;
        height: 812px;
        border-radius: 8px;
        iframe {
            display: block;
            width: 100%;
            height: 812px;
            border-radius: 8px;
        }
        border: #cccccc 1px solid;
    }
</style>
